/**
 * HPH Product Image Zoom
 * Magnifying glass icon on product images.
 * Click opens a lightbox with navigation between images.
 */
(function () {
  function createSvgIcon(type) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');

    if (type === 'zoom') {
      var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', '11'); c.setAttribute('cy', '11'); c.setAttribute('r', '8');
      svg.appendChild(c);
      var l1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l1.setAttribute('x1', '21'); l1.setAttribute('y1', '21'); l1.setAttribute('x2', '16.65'); l1.setAttribute('y2', '16.65');
      svg.appendChild(l1);
      var l2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l2.setAttribute('x1', '11'); l2.setAttribute('y1', '8'); l2.setAttribute('x2', '11'); l2.setAttribute('y2', '14');
      svg.appendChild(l2);
      var l3 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l3.setAttribute('x1', '8'); l3.setAttribute('y1', '11'); l3.setAttribute('x2', '14'); l3.setAttribute('y2', '11');
      svg.appendChild(l3);
    } else if (type === 'prev') {
      var pl = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      pl.setAttribute('points', '15 18 9 12 15 6');
      svg.appendChild(pl);
    } else if (type === 'next') {
      var nl = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      nl.setAttribute('points', '9 18 15 12 9 6');
      svg.appendChild(nl);
    }
    return svg;
  }

  function init() {
    var mediaContainer = document.querySelector('.product-information__media');
    if (!mediaContainer) return;
    if (mediaContainer.querySelector('.hph-zoom-btn')) return;

    // Collect all product image URLs
    var allImages = [];
    var imgElements = mediaContainer.querySelectorAll('.product-media img, slideshow-slide img');
    imgElements.forEach(function (img) {
      var src = img.src || '';
      if (src && allImages.indexOf(src) === -1) {
        src = src.replace(/&width=\d+/, '&width=1200').replace(/\?width=\d+/, '?width=1200');
        allImages.push({ src: src, alt: img.alt || '' });
      }
    });
    if (allImages.length === 0) return;

    var currentIndex = 0;

    // Create zoom button
    var btn = document.createElement('button');
    btn.className = 'hph-zoom-btn';
    btn.setAttribute('aria-label', 'Zoom image');
    btn.appendChild(createSvgIcon('zoom'));

    var slideContainer = mediaContainer.querySelector('slideshow-container') || mediaContainer.querySelector('[ref="slideshowContainer"]') || mediaContainer.querySelector('.media-gallery') || mediaContainer;
    slideContainer.style.position = 'relative';
    slideContainer.appendChild(btn);

    // Create overlay
    var overlay = document.createElement('div');
    overlay.className = 'hph-zoom-overlay';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'hph-zoom-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00D7';
    overlay.appendChild(closeBtn);

    var imgWrap = document.createElement('div');
    imgWrap.className = 'hph-zoom-img-wrap';
    var zoomImg = document.createElement('img');
    zoomImg.className = 'hph-zoom-img';
    imgWrap.appendChild(zoomImg);
    overlay.appendChild(imgWrap);

    // Navigation arrows (only if multiple images)
    var prevBtn, nextBtn, counter;
    if (allImages.length > 1) {
      prevBtn = document.createElement('button');
      prevBtn.className = 'hph-zoom-nav hph-zoom-nav--prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.appendChild(createSvgIcon('prev'));
      overlay.appendChild(prevBtn);

      nextBtn = document.createElement('button');
      nextBtn.className = 'hph-zoom-nav hph-zoom-nav--next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.appendChild(createSvgIcon('next'));
      overlay.appendChild(nextBtn);

      counter = document.createElement('div');
      counter.className = 'hph-zoom-counter';
      overlay.appendChild(counter);
    }

    document.body.appendChild(overlay);

    function showImage(index) {
      currentIndex = index;
      if (currentIndex < 0) currentIndex = allImages.length - 1;
      if (currentIndex >= allImages.length) currentIndex = 0;
      zoomImg.src = allImages[currentIndex].src;
      zoomImg.alt = allImages[currentIndex].alt;
      if (counter) {
        counter.textContent = (currentIndex + 1) + ' / ' + allImages.length;
      }
    }

    function closeOverlay() {
      overlay.classList.remove('hph-zoom-overlay--open');
      document.body.style.overflow = '';
    }

    // Open zoom
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Find which slide is currently visible
      var activeSlide = mediaContainer.querySelector('slideshow-slide:not([aria-hidden="true"]) img');
      if (activeSlide) {
        var activeSrc = activeSlide.src.replace(/&width=\d+/, '&width=1200').replace(/\?width=\d+/, '?width=1200');
        for (var i = 0; i < allImages.length; i++) {
          if (allImages[i].src === activeSrc) { currentIndex = i; break; }
        }
      }

      showImage(currentIndex);
      overlay.classList.add('hph-zoom-overlay--open');
      document.body.style.overflow = 'hidden';
    });

    // Navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showImage(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showImage(currentIndex + 1);
      });
    }

    // Close: click on blue overlay background only (not on photo, wrapper, or arrows)
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) {
      // Don't close if clicking on nav arrows
      if (e.target.closest && e.target.closest('.hph-zoom-nav')) return;
      // Don't close if clicking on the photo or its white container
      if (e.target.closest && e.target.closest('.hph-zoom-img-wrap')) return;
      // Close for everything else (blue overlay background)
      closeOverlay();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('hph-zoom-overlay--open')) return;
      if (e.key === 'Escape') closeOverlay();
      if (e.key === 'ArrowLeft' && allImages.length > 1) showImage(currentIndex - 1);
      if (e.key === 'ArrowRight' && allImages.length > 1) showImage(currentIndex + 1);
    });
  }

  // Make "by Vendor" text clickable (link to brand collection)
  function initVendorLink() {
    var vendorElements = document.querySelectorAll('.product-details p');
    vendorElements.forEach(function (el) {
      var text = el.textContent.trim();
      if (text.indexOf('by ') === 0 && !el.querySelector('a')) {
        var vendorName = text.replace('by ', '');
        var handle = vendorName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
        var link = document.createElement('a');
        link.href = '/collections/' + handle;
        link.className = 'hph-pdp-vendor';
        link.textContent = text;
        el.textContent = '';
        el.appendChild(link);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initVendorLink(); });
  } else {
    init();
    initVendorLink();
  }
  document.addEventListener('shopify:section:load', function () { init(); initVendorLink(); });
})();
